export const MENTION_TRIGGER_PREVIOUS_CHAR_PATTERN = /^$|^[\s"']$/;
